<template>
	<div>
		<div style="font-size: 53px;color: #999;text-align: center;padding-top: 40px;">Freshin</div>
		<div style="font-size: 27px;color: #666;text-align: center;">修改密码</div>
		<div style="margin-top: 20px;display: flex;justify-content: center;">
			<div style="width: 500px;">
				<div style="margin-bottom: 20px;">
					<b style="font-size: 14px;color: #333;display: inline-block;width: 100px;">请输入手机号</b>
					<a-input size="large" v-model="phonenumber" placeholder="请输入手机号" style="display: inline-block;width: 350px;" />
				</div>
				<div style="margin-bottom: 20px;">
					<b style="font-size: 14px;color: #333;display: inline-block;width: 100px;">短信验证码</b>
					<a-input size="large" placeholder="请输入短信验证码" style="display: inline-block;width: 250px;" v-model="postcode" />
					<a-button type="primary" style="display: inline-block;min-width: 110px;" :disabled="isdisable" @click="getcode">
						{{buttoncontent}}
					</a-button>
				</div>
				<div style="text-align: center;">
					<a-button size="large" type="primary" @click="verification">
						确认
					</a-button>
				</div>

			</div>
		</div>
		<div style="position: absolute;bottom: 30px;text-align: center;width: 100%;font-size: 12px;">powered by Freshin</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import CryptoJS from 'crypto-js';

	export default {

		data() {
			return {
				phonenumber: null,
				postcode: null,
				isdisable: false,
				buttoncontent: "发送验证码",
				show: true,
				count: '',
				timer: null,
			}
		},


		methods: {
			moment,
			getcode() {
				var self = this;
				if (!this.phonenumber) {
					return this.$message.error("手机号不能为空")
				}
				if (!(/^1[3456789]\d{9}$/.test(this.phonenumber))) {
					return this.$message.error("手机号格式有误")
				}
				var date = this.moment().format('YYYYMMDDHHmmss');
				var str = this.phonenumber + date;
				var code = CryptoJS.MD5(str).toString(CryptoJS.enc.Hex).replace(/[^0-9]/ig, "").substr(0, 6);
				this.$store.state.code = code;
				this.$axios.get('/basic/getcode', {
					params: {
						phone_number: this.phonenumber,
						date: date
					}
				});
				this.isdisable = true;
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.buttoncontent = this.count + 's';
							this.count--;
						} else {
							this.show = true;
							this.buttoncontent = "发送验证码";
							this.isdisable = false;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000)
				}


			},
			verification() {
				if (this.postcode == this.$store.state.code && this.postcode != null) {
					this.$router.push({
						name: 'repassword',
						params: {
							phone_number: this.phonenumber
						}
					});
				} else {
					return this.$message.error("验证码有误");
				}
			},
		},

	};
</script>



// WEBPACK FOOTER //
// index.vue?58b11528